import { FetchOptions } from '@zapier/transfer-fetch';

/** Given a URL and path, return the joined URL string with either the `ws` or `wss` protocol. */
export const getWebSocketURL = (baseURL: string, path: string): string => {
  // Inspecting whether we're using https to determine if the ws
  // proto should be secured.
  const parsedURL = new URL(baseURL);
  parsedURL.protocol = parsedURL.protocol === 'http:' ? `ws` : `wss`;
  return `${parsedURL.toString()}${path}`;
};

/** Returns an object for managing a websocket connection. */
export const wsClient = function (this: FetchOptions, path: string): WebSocket {
  return new WebSocket(getWebSocketURL(this.baseUrl!, path));
};
